// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  contentful: {
    spaceId: '2rmroywewhth',
    token: '40f7a2df72cc9804499a210a635b9b0c941b1fd416709ee3212062502560b6e1',

    contentTypeIds: {
      product: '2PqfXUJwE8qSYKuM0U6w8M',
      category: '6XwpTaSiiI2Ak2Ww0oi6qa'
    }
  }

};



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/environments/environment.ts